module.exports = __webpack_public_path__ + "media/images/icons/darker-search-587a0a2a5a53e380b4dc4901f7927a72.svg";